<template>
    <!-- Modal -->
    <div class="modal" id="roomChangeModal" tabindex="-1" role="dialog">
        <div class="modal-dialog modal-sm" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h4 class="modal-title">객실 변경</h4>
                    <button type="button" class="btn btn-m flat btn-close" data-dismiss="modal" aria-label="Close">
                        <i class="icon-close"></i>
                    </button>
                </div>
                <div class="modal-body">
                    <p class="text-center mt-40">
                        <b>해당 이용객의 객실을 변경하시겠습니까?</b>
                    </p>
                    <p class="text-center text-666 mt-15">{{selectChangeBooking.roomGuest.visitor.visitorName}} / {{selectChangeBooking.roomGuest.visitor.visitorCompany}} <br />
                        {{ getDateString(selectChangeBooking.fromDate) }} ~ {{getDateString(selectChangeBooking.toDate)}}
                    </p>

                    <div class="text-center text-666 mt-15">
                        <dropdown v-model="selectedRoomId" :datasource="dropdownRooms" displayName="dropdownName"
                                  valueName="roomId" placeholder="IDC 권한 " :isAuto="true" :isSelectedIcon="true" itemDisabledField="disabled"/>
<!--                        <div class="dropdown inline">-->
<!--                            <button class="btn btn-md line-2 dropdown-toggle" data-toggle="dropdown" aria-expanded="false">104호 / Type D</button>-->
<!--                            <div class="dropdown-menu dropdown-menu-scale">-->
<!--                                <a class="dropdown-item selected">메뉴1</a>-->
<!--                                <a class="dropdown-item">메뉴2</a>-->
<!--                                <a class="dropdown-item" disabled="">메뉴3</a>-->
<!--                            </div>-->
<!--                        </div>-->
                    </div>

                    <hr style="width:auto; margin:20px -20px;background-color:#e2e2e2;">
                    <p class="text-light-blue">
                        <i class="icon-dot mr-5"></i>예약확정 상태의 객실 변경 시, 방문객에게 이메일로 통보됩니다.</p>
                    <div class="btn-wrap justify-content-center mt-20 mb-40">
                        <button class="btn btn-lg line-2" data-dismiss="modal" aria-label="Close">
                            <i class="icon-close mr-5"></i>취소</button>
                        <button class="btn btn-lg success" data-dismiss="modal" aria-label="Close" @click="submit()">
                            <i class="icon-check mr-5"></i>적용</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import Dropdown from '@/components/Dropdown.vue';

    export default {
        name: "roomChangeModal",
        components: {Dropdown},
        props: ['selectChangeBooking', 'rooms', 'bookingRooms', 'unavailableRooms'],
        data() {
            return {
                selectedRoomId: null,
                dropdownRooms: null
            }
        },
        watch: {
            selectChangeBooking: function (newVal, oldVal) {
                if (newVal != oldVal) {
                    this.selectedRoomId = newVal.roomId;


                    this.dropdownRooms = JSON.parse(JSON.stringify(this.rooms));
                    let disabledRooms = this.getDropdownDisableRooms();

                    this.dropdownRooms.forEach(room => {
                        if((disabledRooms.filter(dRoomId => dRoomId == room.roomId)).length > 0) room.disabled = "disabled";
                    })
                }
            },
        },
        mounted(){

        },
        methods: {
            submit(){


                let param = {
                    bookingId: this.selectChangeBooking.bookingId,
                    roomId: this.selectedRoomId,
                };

                this.$http.post('/api/private/booking/room/change', param)
                    .then((result) => {
                        this.noti('완료', '객실 변경을 완료하였습니다.', 'success');
                        this.$emit('init');
                    }).catch((e) =>{
                    this.noti('완료', '객실 변경에 실패하였습니다.', 'warning');
                    console.log(e);
                })
            },
            getDropdownDisableRooms(){
                let disableRooms = this.bookingRooms.filter(room => room.bookingStatusId != 3).filter(room => {
                    return (room.fromDate >= this.selectChangeBooking.fromDate && room.fromDate < this.selectChangeBooking.toDate)
                        || (room.toDate > this.selectChangeBooking.fromDate && room.toDate <= this.selectChangeBooking.toDate)
                        || (room.fromDate <= this.selectChangeBooking.fromDate && room.toDate >= this.selectChangeBooking.toDate) ;
                }).map(room => room.roomId);


                let uRooms = this.unavailableRooms.filter(room => {

                    return (room.fromDate >= this.selectChangeBooking.fromDate && room.fromDate <= this.selectChangeBooking.toDate)
                        || (room.toDate >= this.selectChangeBooking.fromDate && room.toDate <= this.selectChangeBooking.toDate)
                        || (room.fromDate <= this.selectChangeBooking.fromDate && room.toDate >= this.selectChangeBooking.toDate) ;
                }).map(room => room.roomId);

                return [...new Set([...disableRooms, ...uRooms])];
            },
            getDateString(timestamp){
                return moment.unix(timestamp/1000).format('YYYY년 MM월 DD일')
            },

        }
    }
</script>

<style scoped>

</style>